<template>
  <div
    class="bto-sb-tost-notifications"
    :title="t('Notifications.Title')"
    v-show="
      showPlacement || showNegotiationToast || toastMessages.length > 0
    "
    :style="[endOfSB ? { position: 'absolute' } : {}]">
    <div class="bto-sb-tost-notifications-content bto-sb-toast-notifications-content">
      <toast-notification v-if="showPlacement" />
      <negotiations-toast v-if="showNegotiationToast" />
      <generic-toast
        v-for="(msg, i) in toastMessages"
        :key="i"
        :message="msg"
        @removeToast="removeToast(i)" />
    </div>
  </div>
</template>
<script>
  import ToastNotification from '@bto-widgets/toast-notification/web';
  import NegotiationsToast from './negotiations-toast';
  import GenericToast from './generic-toast';
  import store from '../../../store';
  import { EventBus } from '../../../services/event-bus-service';
  import HelperService from '../../../services/helper-service';
  import { toastStore } from '@bto-services/toast-notification';
  import { modalStore } from '@bto-services/modal';

  export default {
    name: 'ToastNotifications',
    data() {
      return {
        toastMessages: [],
        endOfSB: false,
      };
    },
    props: {
      platform: {
        type: String,
        default: 'web'
      }
    },
    computed: {
      /**
       * Check if there are negotiations
       */
      showNegotiationToast() {
        // if we are in negotiations tab hide toast notification
        if (this.$route.name === 'negotiations') {
          return false;
        }
        return store.getters.negotiationsCount > 0;
      },
      showPlacement() {
        const noMessages = Object.keys(this.queuedMessages).length === 0;
        // If not messages don't show placement
        if (noMessages) {
          return false;
        }
        // If modal is open don't show any placement messages
        if (modalStore.isOpen && modalStore.modalContent.contentComponent === 'NotificationModal') {
          return false;
        }
        return true;
      },
      queuedMessages() {
        return toastStore.messages;
      },
    },
    components: {
      ToastNotification,
      NegotiationsToast,
      GenericToast,
    },
    created() {
      EventBus.$on('addToastNotification', this.addToastNotification);
      // On WEB listen for scrolling so we can adjust css when get to the end of sportbook
      if (this.platform === 'web' && !this.isFixed()) {
        this.$nextTick(() => {
          document.addEventListener('scroll', HelperService.debounce(this.observeEndSB));
        });
      }
    },
    destroyed() {
      EventBus.$off('addToastNotification', this.addToastNotification);
      document.removeEventListener('scroll', this.observeEndSB);
    },
    methods: {
      isFixed() {
        return APP_SETTINGS.betslip_v2.floatingBetslip || document.body.classList.contains('bto-sb-betslip-fixed-right');
      },
      observeEndSB() {
        let element = document.getElementById('sportbook');
        if (element) {
          let bounding = element.getBoundingClientRect();
          // if we get to the end of the sportbook div set flag to true
          // if (document.body.classList.contains('bto-sb-betslip-fixed-right')) {
          //   if (bounding.bottom <= 0 || bounding.top > 0) {
          //     this.endOfSB = true;
          //     return;
          //   }
          //   this.endOfSB = false;
          //   return;
          // }
          if (
            bounding.bottom <= (window.innerHeight || document.documentElement.clientHeight)
          ) {
            this.endOfSB = true;
            return;
          }
          this.endOfSB = false;
        }
      },
      removeToast(index) {
        this.$delete(this.toastMessages, index);
      },
      addToastNotification(msg) {
        this.toastMessages = [...this.toastMessages, msg];
      },
    },
  };
</script>
